import {
    GET_CAFETERIAS,
    GET_CAFETERIAS_PRICES,
    GET_CAFETERIAS_CATEGORIES,
    CAFETERIA_LOADING,
    CAFETERIA_ERROR
  } from "../actions/CafeteriaActions";

  const initialState = {
    loading: false,
    success: true,
    errorMessage: "",
    cafeterias: [],
    categories: [],
    prices: []
  };

  const CafeteriaReducer = function (state = initialState, action) {
    switch (action.type) {
        case CAFETERIA_LOADING: {
            return {
              ...state,
              loading: true,
              isError: false,
            };
          }
        case GET_CAFETERIAS: {
            return {
              ...state,
              cafeterias: [...action.data],
              loading: false,
            };
          }
        case GET_CAFETERIAS_CATEGORIES: {
            return {
              ...state,
              categories: [...action.data],
              loading: false,
            };
          }
        case GET_CAFETERIAS_PRICES: {
            return {
              ...state,
              prices: [...action.data],
              loading: false,
            };
          }
        case CAFETERIA_ERROR: {
            return {
              ...state,
              isError: true,
              loading: false,
            };
          }
        // case RESET_STORAGE: {
        //     return {
        //       state: initialState,
        //     };
        //   }
        default: {
            return state;
          }
    }

  }

  export default CafeteriaReducer;
